// extracted by mini-css-extract-plugin
export var cardIcon = "_7u-5";
export var cardIconUnframed = "_7u-9";
export var checkboxCard = "_7u-0";
export var checkboxCardSelected = "_7u-4";
export var disabled = "_7u-2";
export var interactive = "_7u-1";
export var outerBorder = "_7u-3";
export var spacerMedium = "_7u-8";
export var spacerSmall = "_7u-7";
export var spacerXsmall = "_7u-6";